import styled from 'styled-components';

export const ManageCookiesStyle = styled.div`
  .cookies-link {
    text-decoration: underline;
    color: ${(props) => props.theme.primary.primary50};
    cursor: pointer;
    &:visited {
      color: ${(props) => props.theme.primary.primary50};
    }
  }
  .MuiPaper-elevation1 {
    box-shadow: none;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    &:before {
      display: none;
    }
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }

  .cookie-item {
    margin-bottom: 42px;
    &__accordion {
      margin-bottom: 24px;
      .MuiButtonBase-root {
        width: auto;
      }
    }
    &__switch {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      .cookie-item-button {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: 46px;
        padding: 12px 24px;
        background: #b0b3b9;
        color: white;
        text-align: center;
        border-radius: 6px;
        border: none;
        &.allow {
          background: #13b966;
        }
        &.reject {
          background: #ea3e4f;
        }
      }
    }
  }
`;
